import { render, staticRenderFns } from "./OrbitalMechanicsETAWarning.vue?vue&type=template&id=c08796a0&scoped=true&"
import script from "./OrbitalMechanicsETAWarning.vue?vue&type=script&lang=js&"
export * from "./OrbitalMechanicsETAWarning.vue?vue&type=script&lang=js&"
import style0 from "./OrbitalMechanicsETAWarning.vue?vue&type=style&index=0&id=c08796a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08796a0",
  null
  
)

export default component.exports